module.exports = __webpack_public_path__ + "static/img/background.5fb687c8.svg";